"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _ContentParser = _interopRequireDefault(require("./entities/ContentParser"));

var _ContentStoreActions = _interopRequireDefault(require("./Stores/ContentStoreActions2"));

var KESI2StoreHelper = /*#__PURE__*/function () {
  function KESI2StoreHelper() {
    (0, _classCallCheck2["default"])(this, KESI2StoreHelper);
  }

  (0, _createClass2["default"])(KESI2StoreHelper, null, [{
    key: "loadContentToStore",
    value: function () {
      var _loadContentToStore = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(data, id, filename, foldername, parsedEntity) {
        var skipFinished,
            entity,
            filenameAndMd5,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                skipFinished = _args.length > 5 && _args[5] !== undefined ? _args[5] : false;
                _context.prev = 1;

                if (!(data.contents && data.contents[id])) {
                  _context.next = 6;
                  break;
                }

                entity = data.contents[id];
                _context.next = 15;
                break;

              case 6:
                filenameAndMd5 = {
                  filename: filename // md5: null   // not available

                };

                if (filename) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", _promise["default"].resolve());

              case 9:
                _context.t0 = parsedEntity;

                if (_context.t0) {
                  _context.next = 14;
                  break;
                }

                _context.next = 13;
                return _ContentParser["default"].parseFromFile(filenameAndMd5, foldername);

              case 13:
                _context.t0 = _context.sent;

              case 14:
                entity = _context.t0;

              case 15:
                if (!(entity === null)) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return", _promise["default"].reject(new Error('file not found or entity not parsed')));

              case 17:
                KESI2StoreHelper.addEntityToStore(entity);

                if (!skipFinished) {
                  KESI2StoreHelper.finishedAddingEntitiesToStore();
                }

                _context.next = 24;
                break;

              case 21:
                _context.prev = 21;
                _context.t1 = _context["catch"](1);
                return _context.abrupt("return", _promise["default"].reject(_context.t1));

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 21]]);
      }));

      function loadContentToStore(_x, _x2, _x3, _x4, _x5) {
        return _loadContentToStore.apply(this, arguments);
      }

      return loadContentToStore;
    }()
  }, {
    key: "addEntityToStore",
    value: function addEntityToStore(entity) {
      _ContentStoreActions["default"].addEntity(entity);
    }
  }, {
    key: "finishedAddingEntitiesToStore",
    value: function finishedAddingEntitiesToStore() {
      _ContentStoreActions["default"].finishedAddingEntities();
    }
  }, {
    key: "unloadContentFromStore",
    value: function unloadContentFromStore(id) {
      // TODO: remove from store
      _ContentStoreActions["default"].removeEntity(id);
    }
  }]);
  return KESI2StoreHelper;
}();

var _default = KESI2StoreHelper;
exports["default"] = _default;